"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGridAggregation = useGridAggregation;
var _react = _interopRequireWildcard(require("react"));
var _createAggregationLookup = require("./createAggregationLookup");
var _xDataGridPro = require("@mui/x-data-grid-pro");
var _gridAggregationUtils = require("./gridAggregationUtils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function useGridAggregation(_ref) {
  var apiRef = _ref.apiRef,
    aggregationModel = _ref.aggregationModel;
  var _rowsKeyRef = _react["default"].useRef('');
  var _prevRulesRef = _react["default"].useRef('');
  var _aggregationModelRef = _react["default"].useRef(null);
  _aggregationModelRef.current = aggregationModel;
  var applyAggregation = _react["default"].useCallback(function () {
    var aggregationLookup = (0, _createAggregationLookup.createAggregationLookup)({
      apiRef: apiRef,
      aggregationModel: _aggregationModelRef.current
    });
    apiRef.current.setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        aggregation: _objectSpread(_objectSpread({}, state.aggregation), {}, {
          lookup: aggregationLookup
        })
      });
    });
  }, [apiRef, aggregationModel]);
  var checkRowsDiff = _react["default"].useCallback(function () {
    var _key = (0, _xDataGridPro.gridDataRowIdsSelector)(apiRef).map(function (id) {
      return "".concat(id, "_").concat(Object.keys(apiRef.current.getRow(id)).join('_'));
    }).join('|||');
    if (_rowsKeyRef.current !== _key) {
      applyAggregation();
      _rowsKeyRef.current = _key;
    }
  }, [applyAggregation]);
  var checkRuleDiff = (0, _react.useCallback)(function () {
    if (_aggregationModelRef.current) {
      var rules = (0, _gridAggregationUtils.getAggregationRules)({
        columnsLookup: (0, _xDataGridPro.gridColumnLookupSelector)(apiRef),
        aggregationModel: aggregationModel
      });
      if (!areRulesEqual(_prevRulesRef.current, rules)) {
        applyAggregation();
        _prevRulesRef.current = rules;
      }
    }
  }, [applyAggregation]);
  _react["default"].useEffect(checkRuleDiff, [applyAggregation]);
  _useGridApiEventHandler(apiRef, 'filteredRowsSet', checkRowsDiff);
  _useGridApiEventHandler(apiRef, 'columnsChange', checkRuleDiff);
}
function areRulesEqual(rule1, rule2) {
  var rile1Keys = Object.keys(rule1);
  var rile2Keys = Object.keys(rule2);
  return rile1Keys.join('') === rile2Keys.join('') && rile1Keys.every(function (k) {
    return rule1[k] === rule2[k];
  });
}
function _useGridApiEventHandler(apiRef, eventName, callback) {
  _react["default"].useEffect(function () {
    var _apiRef$current;
    if (apiRef !== null && apiRef !== void 0 && (_apiRef$current = apiRef.current) !== null && _apiRef$current !== void 0 && _apiRef$current.subscribeEvent) {
      return apiRef.current.subscribeEvent(eventName, callback);
    }
  }, [apiRef, eventName, callback]);
}